import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const current = (i18n.language || 'uz').startsWith('ru') ? 'ru' : 'uz';

  return (
    <div className="lang-switch" role="group" aria-label="Language">
      <button
        type="button"
        className={`lang-switch__btn${current === 'uz' ? ' is-active' : ''}`}
        onClick={() => i18n.changeLanguage('uz')}
      >
        UZ
      </button>
      <button
        type="button"
        className={`lang-switch__btn${current === 'ru' ? ' is-active' : ''}`}
        onClick={() => i18n.changeLanguage('ru')}
      >
        RU
      </button>
    </div>
  );
};

export default LanguageSwitcher;
